export default __webpack_public_path__ + "static/media/reputation-reseaux-sociaux.15eb6bd9.svg";